export const language = () => {
    try {
        let btn = document.querySelector('.header__lang');
        let menu = document.querySelector(".lang__list");

        btn.addEventListener('click', function () {
            console.log(123);
            this.classList.toggle('active');
            menu.classList.toggle('active');
        });
    } catch (e) { }

    try {
        let btn = document.querySelector('.header__lang_mobile');
        let menu = document.querySelector(".lang__list_mobile");

        btn.addEventListener('click', function () {
            console.log(123);
            this.classList.toggle('active');
            menu.classList.toggle('active');
        });
    } catch (e) { }
} 
